var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-1"},[_c('div',[_c('img',{attrs:{"src":_vm.src}})]),_c('p',[_vm._v(_vm._s(_vm.filename))])])}
var staticRenderFns = []

export { render, staticRenderFns }